<template>
  <div class="container">
    <div class="columns">
      <div class="column is-12">
        <h4 class="page-header">
          <b-icon icon="briefcase"></b-icon>
          <span>{{ $ml.get('titles_bookies') }}</span>
        </h4>
        <b-button tag="router-link" type="is-primary" outlined :to="{ path: `/bookies/create` }">
          <span>{{ $ml.get('common_create') }}</span>
        </b-button>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-table
            :data="items"
            :paginated="true"
            :bordered="true"
            :striped="true"
            :loading="loading"
            :per-page="perPage">
          <b-table-column field="bookmaker" :label="$ml.get('bookies_bookmaker')" sortable
                          searchable cell-class="leftal" v-slot="props">
            {{ props.row.bookmaker }}
          </b-table-column>
          <b-table-column field="min_payments" :label="$ml.get('bookies_min_payments')" width="120"
                          sortable cell-class="leftal" v-slot="props">
            <Money v-bind:amount="props.row.min_payments" currency="EUR" v-if="props.row.turnover !== null"/>
          </b-table-column>
          <b-table-column field="price7" :label="$ml.get('bookies_price7')" width="120" sortable
                          cell-class="leftal" v-slot="props">
            <Money v-bind:amount="props.row.price7" currency="EUR" v-if="props.row.turnover !== null"/>
          </b-table-column>
          <b-table-column field="price30" :label="$ml.get('bookies_price30')" width="120" sortable
                          cell-class="leftal" v-slot="props">
            <Money v-bind:amount="props.row.price30" currency="EUR" v-if="props.row.turnover !== null"/>
          </b-table-column>
          <b-table-column v-slot="props">
            <ul class="horizontal">
              <li>
                <a :title="$ml.get('common_edit')" :href="`/bookies/create?id=${props.row.id}`">
                  <b-button size="is-small" type="is-info" outlined>
                    <b-icon size="is-small" icon="pencil"></b-icon>
                  </b-button>
                </a>
              </li>
              <li>
                <b-button size="is-small" type="is-danger" outlined @click="delete_(props.row.id)"
                          :title="$ml.get('common_delete')">
                  <b-icon icon="delete" size="is-small"></b-icon>
                </b-button>
              </li>
            </ul>
          </b-table-column>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Money from "@/components/Money";

export default {
  name: "Index",
  data() {
    return {
      perPage: 15,
      currentPage: 1,
      loading: false,
      items: [],
    }
  },
  components: {
    Money
  },
  methods: {
    retrieve: function () {
      this.loading = true
      Vue.prototype.$http.get(process.env.VUE_APP_API_HOST + `bookies/index`).then(resp => {
        this.items = resp.data.result.items
      }).catch(err => {
        this.flashMessage.error({
          title: this.$ml.get('common_request_failed'),
          message: this.$ml.get('common_request_failed_message'),
        })
      }).finally(() => {
        this.loading = false
      })
    },
    delete_: function (id) {
      if (confirm(this.$ml.get('bookie_delete_confirm'))) {
        this.loading = true
        Vue.prototype.$http.delete(process.env.VUE_APP_API_HOST + `bookies/index?id=${id}`).then(resp => {
          this.retrieve()
          this.flashMessage.success({
            title: this.$ml.get('common_request_success'),
          })
        }).catch(err => {
          this.flashMessage.error({
            title: this.$ml.get('common_request_failed'),
            message: this.$ml.get('common_request_failed_message'),
          })
        }).finally(() => {
          this.loading = false
        })
      }
    },
  },
  mounted() {
    this.retrieve()
  },
  metaInfo() {
    return {
      title: this.$ml.get('titles_bookies')
    }
  }
}
</script>

<style scoped>
</style>
